/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_change_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage change expresses the difference between an old and new value relative to the old value, keeping the sign to show whether it went up or down.`)
};

const es_pct_change_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El cambio porcentual expresa la diferencia entre un valor antiguo y uno nuevo en relación con el valor antiguo, conservando el signo para mostrar si subió o bajó.`)
};

const de_pct_change_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die prozentuale Veränderung drückt den Unterschied zwischen einem alten und einem neuen Wert relativ zum alten Wert aus und behält das Vorzeichen bei, um zu zeigen, ob er gestiegen oder gefallen ist.`)
};

const nl_pct_change_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentageverandering drukt het verschil tussen een oude en nieuwe waarde uit ten opzichte van de oude waarde, met behoud van het teken om te laten zien of de waarde is gestegen of gedaald.`)
};

const fr_pct_change_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La variation en pourcentage exprime la différence entre une ancienne et une nouvelle valeur par rapport à l'ancienne valeur, en conservant le signe pour indiquer si elle a augmenté ou diminué.`)
};

const it_pct_change_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La variazione percentuale esprime la differenza tra un vecchio e un nuovo valore rispetto al vecchio valore, mantenendo il segno per indicare se è aumentato o diminuito.`)
};

const pt_br2_pct_change_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A variação percentual expressa a diferença entre um valor antigo e um novo em relação ao valor antigo, mantendo o sinal para mostrar se ele subiu ou caiu.`)
};

const pt_pct_change_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A variação percentual expressa a diferença entre um valor antigo e um novo valor em relação ao valor antigo, mantendo o sinal para mostrar se subiu ou desceu.`)
};

const ja_pct_change_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント変化は、旧値と新しい値の差を旧値に対する割合で表し、上がったか下がったかを示す符号を保持します。`)
};

const zh_pct_change_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比变化表示新旧数值之间的差异相对于旧数值的比例，并保留符号以显示是上升还是下降。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_change_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_change_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_change_faq1_a", locale)
	if (locale === "en") return en_pct_change_faq1_a(inputs)
	if (locale === "es") return es_pct_change_faq1_a(inputs)
	if (locale === "de") return de_pct_change_faq1_a(inputs)
	if (locale === "nl") return nl_pct_change_faq1_a(inputs)
	if (locale === "fr") return fr_pct_change_faq1_a(inputs)
	if (locale === "it") return it_pct_change_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_change_faq1_a(inputs)
	if (locale === "pt") return pt_pct_change_faq1_a(inputs)
	if (locale === "ja") return ja_pct_change_faq1_a(inputs)
	return zh_pct_change_faq1_a(inputs)
};